// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"135":"253d5213553cc22f","354":"8d3bdd8638a3ad85","2537":"575f0e80f313c214","4368":"4f34b61beea3f3ce","8095":"ce8b6effe3d49a44"}[chunkId] + ".css";
};